import { RESET_STATE } from 'store/global/actions';

import { CONTROL_UI_ACTION_TYPE } from '../actions';

const initialState = {
  activeTemplateId: null,
  activeTemplateCategoryId: null,
};

const controlUIReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CONTROL_UI_ACTION_TYPE.SET_ACTIVE_TEMPLATE_DATA:
      return {
        activeTemplateId: payload?.activeTemplateId,
        activeTemplateCategoryId: payload?.activeTemplateCategoryId,
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default controlUIReducer;
